<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">

        <div class=" bgWight formStyle posRel uploadDocumenti">
          <div class="headForm">
            <div class="row g-3 ">
              <div class="text-center">
                <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.webp">
              </div>
            </div>
          </div>
          <div class="container ">
            <div class="row g-2 text-center">
              <div class="titleThanksBlack">Manca solo l'ultima informazione!</div>
              <p style="text-align: left;">Viaggiavano con te altre persone ?</p>
              <p class="px-5" style="text-align:justify; margin-top: 20px" ><span class="listGreenThanks">1. Sì, NELLA STESSA PRENOTAZIONE:</span><span class="my-5"> aggiungile <span style="font-weight: bold; text-decoration: underline;">ORA</span> cliccando sul bottone «aggiungi passeggero» <span style="font-weight: bold; text-decoration: underline;">senza aprire altre richieste.</span></span></p>
              <p class="px-5" style="text-align:justify; margin-top: 10px"><span class="listGreenThanks">2. Sì, MA CON PRENOTAZIONE DIFFERENTE:</span><span class="my-5"> <span style="font-weight: bold; text-decoration: underline;"> NON INSERIRLE ALL’INTERNO DI QUESTA PRATICA</span>, clicca su «concludi» e procedi con una nuova richiesta nella prossima pagina.</span></p>
              <p class="px-5" style="text-align:justify; margin-top: 10px"><span class="listGreenThanks">3. NO, VIAGGIAVO DA SOLO:</span><span class="my-5"> clicca su «concludi» .</span></p>
            </div>
            <div class="row g-2 my-5">
              <div class="col-lg-4 col-md-12 col-xs-12 text-left offset-lg-0 offset-md-4 offset-4">
                <p>Passeggeri inseriti:</p>
                <p class="evidenziatore" v-for="passeggero in s_passeggeri_inseriti">{{ passeggero.nome }} {{ passeggero.cognome }}</p>
              </div>
              <div class="col-lg-4 col-md-6 text-center"><button type="submit" class="btn styleBtn mb-3  addPass" @click="nuovoPasseggero"><span class="plusFix"></span>Aggiungi passeggero</button></div>
              <div class="col-lg-4 col-md-6 text-center"><button type="submit" class="btn styleBtn mb-3 endBtn" @click="concludi()">Concludi</button></div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>
</template>

<script>
import {computed} from "vue";
import {useStore} from "vuex"
import { submitConclusioneProcesso } from "@/lib/submit";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";

export default {
  name: "ThankYou1",
  setup(){
    const store = useStore();
    const s_ticketref = computed(()=>store.state.compilazione.tktref);
    const s_ticketid = computed(()=>store.state.compilazione.ticketid);
    const s_psgref = computed(()=>store.state.passeggeri.nextpsgref);
    const s_tipodisservizio = computed(()=>store.state.volo.tipoproblema);
    const s_passeggeri_inseriti = computed(()=>store.state.passeggeri.passeggeri);
    const s_giropasseggeroaggiuntivo = computed(()=>store.state.compilazione.giropasseggeroaggiuntivo);
    const s_nextpsgref = computed(()=>store.state.passeggeri.nextpsgref);
    const s_step10_inviato = computed( ()=>store.state.gtmstate.step10inviato);
    return {
      s_psgref,
      s_ticketid,
      s_ticketref,
      s_tipodisservizio,
      s_passeggeri_inseriti,
      s_giropasseggeroaggiuntivo,
      s_nextpsgref,
      s_step10_inviato,
      setGiroPasseggeroAggiuntivo: function(){
        store.dispatch('compilazione/commitSetGiroPasseggeroAggiuntivo',1);
      },
      setNextPsgRef:(value)=>{
        store.dispatch("passeggeri/commitSetNextPsgRef",value);
      },
      setStep10Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio10',true);
      }
    }
  },
  components : {
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
  },
  methods:{
    nuovoPasseggero(){
      this.setGiroPasseggeroAggiuntivo();
      this.setNextPsgRef(null);
      this.$router.push({name:'passeggero1'});
    },
    concludi(){
      submitConclusioneProcesso(this.s_ticketref).then((result)=>{
        console.log(result);
        this.$router.push({name:'ultimostep'});
      })

    }
  },
  mounted(){
    if(this.s_ticketref === null){
      this.$router.push({name:'step1'});
    }else{
      if(!this.s_step10_inviato) {
        this.setStep10Inviato();
        this.$gtm.trackEvent({
              event: 'step_visitato',
              value: 10,
            }
        );

      }
    }
  },
}
</script>

<style scoped>

</style>